import clsx from 'clsx'
import React from 'react'
import { useTranslation } from 'react-i18next'

import type { FavoriteItemListFloatingFooterProps } from './type'

import { AddShoppingCartFilledIcon } from '@/components/icons/AddShoppingCartFilled'
import { ActionFloatingFooter } from '@/components/layout'
import { Button, Icon } from '@/components/ui'

export const FavoriteItemListFloatingFooter = ({
  inputRef,
  displayMode,
  isLoading,
  disabledAddCart = false,
  onCancel,
  onClickAddCart,
  onClickUpdate,
}: FavoriteItemListFloatingFooterProps) => {
  const { t } = useTranslation()

  return (
    <ActionFloatingFooter inputRef={inputRef}>
      {displayMode === 'main' && (
        <div>
          <Button
            isLoading={isLoading}
            startIcon={
              <Icon
                icon={AddShoppingCartFilledIcon}
                size={'lg'}
                color={'white'}
              />
            }
            disabled={disabledAddCart}
            onClick={onClickAddCart}
          >
            {`${t('cart.item.add')}`}
          </Button>
        </div>
      )}

      {displayMode === 'sort' && (
        <div
          className={clsx(
            'tw-w-full',
            'tw-grid tw-grid-cols-5 tw-items-center lg:tw-grid-cols-2',
            'tw-gap-2 lg:tw-gap-4'
          )}
        >
          <div className={clsx('tw-col-span-2 lg:tw-col-span-1')}>
            <Button variant="normal" disabled={isLoading} onClick={onCancel}>
              {t('favorite.modal.close')}
            </Button>
          </div>
          <div className={clsx('tw-col-span-3 lg:tw-col-span-1')}>
            <Button
              variant="primary"
              isLoading={isLoading}
              onClick={onClickUpdate}
            >
              {`${t('favorite.notification.update')}`}
            </Button>
          </div>
        </div>
      )}

      {displayMode === 'edit' && (
        <div>
          <Button variant="normal" disabled={isLoading} onClick={onCancel}>
            {t('favorite.modal.close')}
          </Button>
        </div>
      )}
    </ActionFloatingFooter>
  )
}
